/**
 * Frontend copy of the backend fiction disclaimer (app/backend/disclaimer.js).
 * Kept in sync by hand; the P2.1 test asserts the footer shows a fiction statement.
 * The product is a ranked listing, not a donation / charity / investment / rescue.
 */

export const FICTION_DISCLAIMER =
  "GetMeHome.lol is a work of fiction and an art project. Payments buy a ranked " +
  "listing on this site. They are not a donation, charity, investment, or rescue. " +
  "No real person is being rescued.";

// Short form used in the footer (compact, one line).
export const FICTION_DISCLAIMER_SHORT = FICTION_DISCLAIMER;

export default FICTION_DISCLAIMER;
